// Mock data for testing V2 pagination functionality when backend is unavailable

// Generate mock product for testing
const generateMockProduct = (id) => ({
  _id: `mock-product-${id}`,
  name: `Mock Product ${id}`,
  description: `Description for mock product ${id}`,
  price: Math.floor(Math.random() * 100) + 10,
  imageUrl: `/api/placeholder/300/300?text=Product${id}`,
  brand: `Brand ${Math.floor(id / 5) + 1}`,
  category: 'Health & Wellness',
  subcategory: 'Supplements',
  available: true,
  countries: ['canada'],
  featured: Math.random() > 0.8
});

// Generate mock V2 API response
export const generateMockV2Response = (page = 1, limit = 20, total = 250) => {
  const startIndex = (page - 1) * limit;
  const endIndex = Math.min(startIndex + limit, total);
  const products = [];
  
  for (let i = startIndex; i < endIndex; i++) {
    products.push(generateMockProduct(i + 1));
  }
  
  const hasMore = endIndex < total;
  const nextToken = hasMore ? `token-page-${page + 1}` : null;
  
  return {
    products,
    pagination: {
      hasMore,
      nextToken,
      total,
      currentPage: page,
      totalPages: Math.ceil(total / limit)
    }
  };
};

// Mock V1 API response for fallback testing
export const generateMockV1Response = (limit = 50) => {
  const products = [];
  for (let i = 0; i < limit; i++) {
    products.push(generateMockProduct(i + 1));
  }
  return products;
};

// Test various edge cases
export const mockEdgeCases = {
  // Empty response
  empty: {
    products: [],
    pagination: {
      hasMore: false,
      nextToken: null,
      total: 0
    }
  },
  
  // Single page response
  singlePage: {
    products: Array.from({ length: 5 }, (_, i) => generateMockProduct(i + 1)),
    pagination: {
      hasMore: false,
      nextToken: null,
      total: 5
    }
  },
  
  // Large dataset first page
  largeDataset: generateMockV2Response(1, 100, 1000),
  
  // API error simulation
  error: new Error('Mock API Error for testing')
};

export default {
  generateMockV2Response,
  generateMockV1Response,
  mockEdgeCases
};
